import { render, staticRenderFns } from "./WarehouseFormPopup.vue?vue&type=template&id=670ccf4e&"
import script from "./WarehouseFormPopup.vue?vue&type=script&lang=ts&"
export * from "./WarehouseFormPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports